import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const OFFER_DEADLINE = new Date('2026-03-31T23:59:00').getTime();

const Header = () => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = OFFER_DEADLINE - now;
      if (distance < 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        clearInterval(timer);
        return;
      }
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      setTimeLeft({ days, hours, minutes, seconds });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <motion.header
      className="sticky top-0 z-50 bg-white/95 backdrop-blur-lg border-b border-gray-200 shadow-sm"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="hidden md:flex items-center">
            <div className="logo-banner">
              <span className="font-serif font-bold text-xl text-white">My Webinar</span>
            </div>
          </div>

          <div className="flex md:hidden flex-1 mobile-center-logo">
            <div className="logo-banner mb-1">
              <span className="font-serif font-bold text-lg text-white">My Webinar</span>
            </div>
            <div className="shake-shine-cta bg-gold text-white px-3 py-1 rounded-full text-xs font-bold mt-1">
              🔥 FY End Deal
            </div>
          </div>

          <div className="hidden md:flex items-center space-x-6">
            <div className="countdown-shine flex items-center space-x-4 px-4 py-2 rounded-lg">
              <span className="text-sm font-bold text-gray-900">FY End Offer Ends In:</span>
              <div className="flex space-x-2 text-sm font-bold text-primary-blue">
                <span>{timeLeft.days}d</span>
                <span>{timeLeft.hours}h</span>
                <span>{timeLeft.minutes}m</span>
                <span>{timeLeft.seconds}s</span>
              </div>
            </div>
            <motion.button
              className="shake-shine-cta bg-primary-blue hover:bg-dark-blue text-white px-6 py-2 rounded-lg font-semibold transition-all border-2 border-gold"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Get FY End Deal
            </motion.button>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;